import { AlertTriangle, CheckIcon, Loader2, MailIcon, PhoneIcon } from 'lucide-react'
import React, { useState } from 'react'
import { RadioGroup, RadioGroupItem } from '../../components/ui/radio-group'
import { Label } from '../../components/ui/label'
import { Button } from '../../components/ui/button'
import { Input } from '../../components/ui/input'
import z from 'zod'
import axios from 'axios'
import { useTranslation } from 'react-i18next'

const StartWithPeppolPage = () => {
    const { t } = useTranslation();

    const [step, setstep] = useState(0);
    const [type_company, settype_company] = useState<string | undefined>(undefined);
    const [how_invoice, sethow_invoice] = useState<string | undefined>(undefined);
    const [software_xml, setsoftware_xml] = useState<string | undefined>(undefined);

    function handleNextStep() {
        switch (step) {
            case 0:
                if(type_company){
                    setstep(1);
                }
                break;
            case 1:
                if(how_invoice === 'a' || how_invoice === 'b'){
                    setstep(4)
                    break;
                }
                if(how_invoice === 'c'){
                    setstep(2)
                    break;
                }
                break;
            case 2:
                if(software_xml){
                    setstep(3);
                }
                break;
            default:
                break;
        }
    }

    function handleBackStep() {
        switch (step) {
            case 0:
                break;
            case 1:
                setstep(0);
                break;
            case 2:
                setstep(1);
                break;
            case 3:
                setstep(2);
                break;
            case 4:
                setstep(1);
                break;
            default:
                break;
        }
    }

    const [isError, setisError] = useState(false);
    const [isSuccess, setisSuccess] = useState(false);
    const [isPending, setisPending] = useState(false);
    const [name, setname] = useState('');
    const [email, setemail] = useState('');
    const [organisation, setorganisation] = useState('');

    async function handleSubmit() { 
        try {
            setisPending(true);
            const { data } = await axios.post(`https://apiregistrationpeppol.qastan.be/peppolregistration/registration`, {
                name: name,
                firm: organisation,
                emailaddress:email
            })
            if(data.errorcode!==0){throw new Error(data.messagge)}
            setisSuccess(true);
        } catch (e) {
            setisError(true);
        } finally {
            setisPending(false);
        }
    }

    function isComplete() {
        try {
            const s = z.object({
                name: z.string().min(1),
                email: z.string().email(),
                organisation: z.string().min(1)
            })
            s.parse({
                name: name,
                email: email,
                organisation: organisation
            });
            return true;
        } catch (e) {
            return false;
        }
    }

  return (
    <div className='min-h-dvh'>
        <div className='container flex flex-col items-center justify-center w-full gap-8 my-12'>
            <h1 className='text-4xl font-bold text-center md:text-5xl'>{t('start-with-peppol.Start met Peppol')}</h1>
            <p className='text-center max-w-[1000px]'>{(t('start-with-peppol.Je wil starten met elektronische facturatie via Peppol'))}</p>
            <div className='flex flex-wrap items-center gap-4'>
                <a href="tel:+32 (0)51 31 07 44" className='flex items-center gap-2 px-3 py-2 text-sm font-medium border rounded-full hover:bg-white hover:shadow-sm border-neutral-200'><PhoneIcon className='w-4 h-4'/> +32 (0)51 31 07 44</a>
                <a href="mailto:peppol@qastan.be" className='flex items-center gap-2 px-3 py-2 text-sm font-medium border rounded-full hover:bg-white hover:shadow-sm border-neutral-200'><MailIcon className='w-4 h-4'/> peppol@qastan.be</a>
            </div>
        </div>

        <div className='container flex flex-col items-center'>
            <div className='relative flex flex-col items-center justify-center w-full max-w-xl gap-8 p-8 overflow-hidden bg-white border shadow-lg md:gap-12 rounded-xl'>

                <div className={`${step === 0 ? 'flex' : 'hidden'} flex-col w-full`}>
                    <p className='mb-8 text-xl font-bold'>{t('start-with-peppol.Welk type onderneming ben jij?')}</p>
                
                    <RadioGroup value={type_company} onValueChange={(v)=>{settype_company(v);}}>
                        <div className='flex items-center gap-2'>
                            <RadioGroupItem value='a' id='independent'/>
                            <Label htmlFor='independent'>{t('start-with-peppol.Ik ben zelfstandig of heb een vrij beroep')}</Label>
                        </div>
                        <div className='flex items-center gap-2'>
                            <RadioGroupItem value='b' id='small company'/>
                            <Label htmlFor='small company'>{t('start-with-peppol.Een kleine vennootschap')}</Label>
                        </div>
                        <div className='flex items-center gap-2'>
                            <RadioGroupItem value='c' id='other'/>
                            <Label htmlFor='other'>{t('start-with-peppol.Andere')}</Label>
                        </div>
                    </RadioGroup>
                </div>

                <div className={`${step === 1 ? 'flex' : 'hidden'} flex-col w-full`}>
                    <p className='mb-8 text-xl font-bold'>{t('start-with-peppol.Hoe maak jij je facturen op')}</p>
                
                    <RadioGroup value={how_invoice} onValueChange={(v)=>{sethow_invoice(v);}}>
                        <div className='flex items-center gap-2'>
                            <RadioGroupItem value='a' id='paper'/>
                            <Label htmlFor='paper'>{t('start-with-peppol.Papier')}</Label>
                        </div>
                        <div className='flex items-center gap-2'>
                            <RadioGroupItem value='b' id='excel or word'/>
                            <Label htmlFor='excel or word'>{t('start-with-peppol.Excel of Word')}</Label>
                        </div>
                        <div className='flex items-center gap-2'>
                            <RadioGroupItem value='c' id='softwarepakket'/>
                            <Label htmlFor='softwarepakket'>{t('start-with-peppol.In een softwarepakket')}</Label>
                        </div>
                    </RadioGroup>
                </div>

                <div className={`${step === 2 ? 'flex' : 'hidden'} flex-col w-full`}>
                    <p className='mb-8 text-xl font-bold'>{t('start-with-peppol.Kan het softwarepakket XML of UBL')}</p>
                
                    <RadioGroup value={software_xml} onValueChange={(v)=>{setsoftware_xml(v);}}>
                        <div className='flex items-center gap-2'>
                            <RadioGroupItem value='a' id='no idea'/>
                            <Label htmlFor='no idea'>{t('start-with-peppol.Geen idee')}</Label>
                        </div>
                        <div className='flex items-center gap-2'>
                            <RadioGroupItem value='b' id='yes xml ubl'/>
                            <Label htmlFor='yes xml ubl'>{t('start-with-peppol.Ja')}</Label>
                        </div>
                    </RadioGroup>
                </div>

                <div className={`${step === 3 ? 'flex' : 'hidden'} flex-col w-full`}>
                    <p className='mb-8 text-xl font-bold'>{t('start-with-peppol.Je bent helemaal klaar voor Peppol')}</p>

                    {software_xml === 'b' && 
                    <p>{t('start-with-peppol.Vergeet je echter niet te registreren')} <a href="https://peppol.org/members/peppol-certified-service-providers/" className='underline text-legoOrange'>link.</a></p>
                    }

                    {software_xml === 'a' &&
                    <div>
                        <p>{t('start-with-peppol.We kijken het graag even voor jou na')}</p>

                        <div className='flex flex-col items-center gap-2 mt-4'>
                            <Input value={name} onChange={(e)=>{setname(e.target.value)}} placeholder={`${t('start-with-peppol.Uw naam')}`} id='name'/>
                            <Input value={email} onChange={(e)=>{setemail(e.target.value)}} placeholder={`${t('start-with-peppol.Uw email')}`} id='email'/>
                            <Input value={organisation} onChange={(e)=>{setorganisation(e.target.value)}} placeholder={`${t('start-with-peppol.Uw organisatie')}`} id='organisation'/>
                            <Button 
                                onClick={()=>{handleSubmit()}} 
                                disabled={!isComplete() || isPending || isError || isSuccess}
                                className='flex items-center gap-2 !text-white rounded-md'
                            >
                                {isPending && <><Loader2 className='w-4 h-4 text-white stroke-white animate-spin'/><span className='text-white'>{t('start-with-peppol.Bezig met versturen')}</span></>}
                                {isSuccess && <><CheckIcon className='w-4 h-4 text-white stroke-white'/><span className='text-white'>{t('start-with-peppol.Succesvol verstuurd')}</span></>}
                                {isError && <><AlertTriangle className='w-4 h-4 text-white stroke-white'/><span className='text-white'>{t('start-with-peppol.Er is een fout opgetreden')}</span></>}
                                {(!isPending && !isSuccess && !isError) && <span className='text-white'>{t('start-with-peppol.Verzenden')}</span>}
                            </Button>
                        </div>
                    </div>
                    }
                </div>

                <div className={`${step === 4 ? 'flex' : 'hidden'} flex-col w-full`}>
                    <p className='mb-8 text-xl font-bold'>{t('start-with-peppol.Opgelet')}</p>
                
                    <p>{t('start-with-peppol.Vanaf januari')} <a href="https://qadmin.qastan.be/" target="_blank" className='underline text-legoOrange'>link.</a> </p>
                </div>
                
                {(step !== 4 && step !== 3) && 
                <div className='flex items-center justify-between w-full gap-2'>
                    {step > 0 ? <Button  className='rounded-full' variant='outline' disabled={step === 0} onClick={()=>{handleBackStep()}}>{t('start-with-peppol.Ga terug')}</Button> : <i></i>}
                    <Button onClick={()=>{handleNextStep()}} className='rounded-full'>{t('start-with-peppol.Volgende')}</Button>
                </div>
                }
                
            </div>
        </div>
    </div>
  )
}

export default StartWithPeppolPage